
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize dataLayer for GA4 only
window.dataLayer = window.dataLayer || [];
function gtag(...args: any[]) {
  window.dataLayer.push(arguments);
}
// Global helper function
window.gtag = gtag;

// Set default consent with basic analytics enabled (Consent Mode v2)
gtag('consent', 'default', {
  'analytics_storage': 'granted',
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'functionality_storage': 'granted',
  'personalization_storage': 'denied',
  'security_storage': 'granted'
});

console.log("GA4 consent set to granted by default for organic traffic tracking");

// Initialize GA4 directly
gtag('js', new Date());
gtag('config', 'G-YYRPWSV3FY', {
  'consent_mode': 'advanced',
  'send_page_view': true
});

console.log("GA4 initialized with basic consent granted");

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
